var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.13,
    height: 55.597,
    viewBox: "0 0 70.13 55.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171811",
    "data-name": "\\uADF8\\uB8F9 171811",
    transform: "translate(-915.96 -1325.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171809",
    "data-name": "\\uADF8\\uB8F9 171809",
    transform: "translate(-4.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_37",
    "data-name": "\\uD569\\uCE58\\uAE30 37",
    d: "M0,55.6V29.316q0-.072,0-.155v-.739H.013C.177,23.053,2.192,3.741,22.525,0A71.383,71.383,0,0,1,25.7,8.891S12.4,10.159,13.944,28.422H27.666V55.6Z",
    transform: "translate(920.001 1325.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_38",
    "data-name": "\\uD569\\uCE58\\uAE30 38",
    d: "M0,55.6V29.316q0-.072,0-.155v-.739H.013C.177,23.053,2.192,3.741,22.525,0A71.383,71.383,0,0,1,25.7,8.891S12.4,10.159,13.944,28.422H27.666V55.6Z",
    transform: "translate(962.466 1325.282)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackQuotes);
export default __webpack_public_path__ + "static/media/blackQuotes.2f54a8dda2e35c4fc6f7964cc85c9e50.svg";
export { ForwardRef as ReactComponent };